import { Controller } from "@hotwired/stimulus"

//
//
// Connects to data-controller="dependent-form-element"

export default class extends Controller {
  static values = {
    parentfields: String,
    url: String
  }

  connect() {
    this.form = this.element.closest('form')
    this.formElementsController = this.application.getControllerForElementAndIdentifier(this.form, 'dependent-form-elements')
    this.formElementsController.dependentElementConnected(this.dependentElement())
  }

  dependentElement() {
    return this.element
  }

  parentFieldElements() {
    let fieldElements = []
    this.parentfieldsValue.split(',').forEach(parentName => {
      let parentElement = this.form.querySelector(`[name$="[${parentName}]"]:not([type="hidden"])`)
        || this.form.querySelector(`[name$="[${parentName}][]"]:not([type="hidden"])`)
        || this.form.querySelector(`[id="${parentName}"]`)
      fieldElements.push(parentElement)
    });
    return fieldElements.filter((el) => el != null)
  }

  reRenderUrl() {
    return this.urlValue
  }
}
